import { matchPath, useLocation } from 'react-router-dom';

export type ShellFrameKind = 'default' | 'focus';

export default function useShellFrameKind(
  focusPaths: string[],
): ShellFrameKind {
  const { pathname } = useLocation();

  return focusPaths.some(path => matchPath(path, pathname))
    ? 'focus'
    : 'default';
}
